const messages = {
  en: {
    contact: 'contact Customer Support.',
    yes: 'Yes',
    no: 'No',
    support: 'Support',
    help: 'Click for Help',
    resolved: 'Issue Resolved?',
    back: 'Back'
  },
  'es-ud': {
    contact: 'contacte a Atención al Cliente',
    yes: 'Sí',
    no: 'No',
    support: 'Ayuda',
    help: 'Haga Clic Aquí',
    resolved: '¿Problema Resuelto?',
    back: 'Regresar'
  },
  es: {
    contact: 'contacta a Atención al Cliente',
    yes: 'Sí',
    no: 'No',
    support: 'Ayuda',
    help: 'Haz Clic Aquí',
    resolved: '¿Problema Resuelto?',
    back: 'Regresar'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/SingleGuide/messages.js